<template>
    <div>   
     <br><br><br><br><br>
     <div class="container">
        <div class="row justify-content-center" >
            <div class="col-md-3"></div>
            <div class="col-md-6">
                <center>
                    <p style="color: #646464; font-size: 45px;" class="font-light">Cantado Terminales</p>
                    <br><br>
                    <b-button block variant="primary" style=" background: #039cf3; border-color: #039cf3;  color: #fff; font-weight: lighter;"  @click="reporteExc()">
                       <b>Descargar reporte Cantado Terminales </b>  <b-spinner small v-if="loader"></b-spinner>
                    </b-button>
                    <hr>
                </center>
            </div>
            <div class="col-md-3"></div>
        </div>
        
     </div>
    </div>
</template>
<script>
export default {
    name:"Reporte",
    data() {
     return {
        loader:false,
        idpdv:"",
        mrt:""
     }
    },
    methods:{
        reporteExc(){
            this.loader = true;
            this.$fileDownload(
                        this.$api.baseUri + 'cantado/reporteExterno',
                        "reporte-cantado.xlsx",
                ).then(
                    () => {
                        this.loader = false;
                    }
                )
        }
    }
}
</script>
